import { useState, useEffect, useRef } from 'react';

// Cola del reloj, en minutos de la escala del escaneo. El frente llega a los
// 30 minutos y el reloj sigue corriendo un poco mas, a la misma velocidad,
// para que las estelas que arrastran las capas animadas (los arcos duran 4,5
// minutos y las ondas 3) alcancen a apagarse. Sin esta cola, todo lo que
// quedaba dentro de la ventana al detenerse el reloj se congelaba encendido:
// arcos hacia los servicios mas lejanos y celdas del ultimo anillo, encendidos
// sin que nada lo explicara. Lo que queda al final son los marcadores de
// servicio, que si son el resultado del escaneo.
const COLA_MINUTOS = 5;

export function useReloj(activo, sinMovimiento, duracionMs = 6000, maxMinutos = 30) {
  const [t, setT] = useState(0);
  const inicioRef = useRef(0);
  const frameRef = useRef(null);

  useEffect(() => {
    if (!activo) {
      setT(0);
      return undefined;
    }

    const finalMinutos = maxMinutos + COLA_MINUTOS;

    // Sin movimiento (preferencia del navegador o boton de la leyenda) no se
    // anima el barrido: el resultado completo aparece de inmediato, ya con las
    // estelas apagadas.
    if (sinMovimiento) {
      setT(finalMinutos);
      return undefined;
    }

    inicioRef.current = performance.now();
    // la cola corre a la misma velocidad que el barrido
    const duracionTotal = (duracionMs * finalMinutos) / maxMinutos;

    const avanzar = () => {
      const transcurrido = performance.now() - inicioRef.current;
      const progreso = Math.min(transcurrido / duracionTotal, 1);
      setT(progreso * finalMinutos);

      if (progreso < 1) {
        frameRef.current = requestAnimationFrame(avanzar);
      }
    };

    frameRef.current = requestAnimationFrame(avanzar);

    return () => {
      if (frameRef.current !== null) {
        cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
      }
    };
  }, [activo, sinMovimiento, duracionMs, maxMinutos]);

  return t;
}
